import { Form, Row, Col, Button } from "react-bootstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { logoutModal } from "../../../slices/common/reducer";
import { logoutUser } from "../service/loginService";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const LayoutModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutShow = useSelector((state) => state.common.logoutShow);

  const handleClose = () => {
    dispatch(logoutModal(false));
  };

  const handleConfirmLogout = () => {
    handleClose();
    navigate("/");
    logoutUser(navigate);
  };

  useEffect(() => {
    const handleLocationChange = () => {
      if (logoutShow) {
        handleClose();
      }
    };
    handleLocationChange();
  }, [location, navigate]);

  return (
    <Modal
      isOpen={logoutShow}
      onHide={() => handleClose()}
      //   centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <ModalBody className="modal-body">
        <h5>Are you sure you want to logout?</h5>
        <div className="button-wrapper">
          <button
            type="submit"
            className="btn btn-primary save"
            id="addNewMember"
            onClick={handleConfirmLogout}
          >
            Yes
          </button>
          <button
            type="submit"
            className="btn btn-outline-primary cancel"
            onClick={() => handleClose(false)}
          >
            No
          </button>
        </div>
        {/* </Col>
        </Row> */}
      </ModalBody>
    </Modal>
  );
};

export default LayoutModal;
